import React from 'react';
import { VerticalSp, RowColum, ContentsArea, MediaQuery } from '../../components/Common';
import images from '../../assets';
import { withTranslation } from 'react-i18next';

class Page404 extends React.Component {
  state = {};

  render() {
    const { t } = this.props;
    return (
      <RowColum>
        <ContentsArea style={{ maxWidth: 1200 }}>
          <div
            style={{
              height: '80vh',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img alt="" src={images.icon_err_404} />
            <VerticalSp sp={'1.6vw'} style={{ minHeight: 10, maxHeight: 35 }} />
            <MediaQuery min={800}>
              <div
                style={{
                  fontFamily: 'NSCJKrB',
                  fontSize: 30,
                  color: 'black',
                  textAlign: 'center',
                  lineHeight: 2,
                  wordBreak: 'keep-all',
                }}
              >
                {t('404_page_not_found')}
              </div>
            </MediaQuery>
            <MediaQuery max={799}>
              <div
                style={{
                  fontFamily: 'NSCJKrB',
                  fontSize: 20,
                  color: 'black',
                  textAlign: 'center',
                  lineHeight: 2,
                  wordBreak: 'keep-all',
                }}
              >
                {t('404_page_not_found')}
              </div>
            </MediaQuery>
            <VerticalSp sp={'0.6vw'} style={{ minHeight: 5, maxHeight: 10 }} />
            <MediaQuery min={800}>
              <div
                style={{
                  fontFamily: 'NSCJKrR',
                  fontSize: 18,
                  color: '#999999',
                  textAlign: 'center',
                  lineHeight: 2,
                  wordBreak: 'keep-all',
                }}
              >
                {t('404_detail_1')}
              </div>
              <div
                style={{
                  fontFamily: 'NSCJKrR',
                  fontSize: 18,
                  color: '#999999',
                  textAlign: 'center',
                  lineHeight: 2,
                  wordBreak: 'keep-all',
                }}
              >
                {t('404_detail_2')}
              </div>
              <div
                style={{
                  fontFamily: 'NSCJKrR',
                  fontSize: 18,
                  color: '#999999',
                  textAlign: 'center',
                  lineHeight: 2,
                  wordBreak: 'keep-all',
                }}
              >
                {t('404_detail_3')}
              </div>
            </MediaQuery>
            <MediaQuery max={799}>
              <div
                style={{
                  fontFamily: 'NSCJKrR',
                  fontSize: 14,
                  color: '#999999',
                  textAlign: 'center',
                  lineHeight: 2,
                  wordBreak: 'keep-all',
                }}
              >
                {t('404_detail_1')}
              </div>
              <div
                style={{
                  fontFamily: 'NSCJKrR',
                  fontSize: 14,
                  color: '#999999',
                  textAlign: 'center',
                  lineHeight: 2,
                  wordBreak: 'keep-all',
                }}
              >
                {t('404_detail_2')}
              </div>
              <div
                style={{
                  fontFamily: 'NSCJKrR',
                  fontSize: 14,
                  color: '#999999',
                  textAlign: 'center',
                  lineHeight: 2,
                  wordBreak: 'keep-all',
                }}
              >
                {t('404_detail_3')}
              </div>
            </MediaQuery>
          </div>
        </ContentsArea>
      </RowColum>
    );
  }
}
export default withTranslation()(Page404);
